import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function ProgressBar({ value = 0, color = t.emerald, size = "md", label, showPercent }) {
  const heights = { sm: 4, md: 8 };
  const h = heights[size] || heights.md;

  return (
    <div style={{ fontFamily: font.body }}>
      {(label || showPercent) && (
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
          {label && <span style={{ fontSize: 12, fontWeight: 600, color: t.textSecondary }}>{label}</span>}
          {showPercent && <span style={{ fontSize: 11, fontWeight: 700, color: t.textMuted, fontFamily: font.mono }}>{Math.round(value)}%</span>}
        </div>
      )}
      <div style={{ width: "100%", height: h, borderRadius: 99, background: t.border, overflow: "hidden" }}>
        <div style={{
          width: `${Math.min(100, Math.max(0, value))}%`,
          height: "100%", borderRadius: 99,
          background: `linear-gradient(90deg, ${color}, ${color}dd)`,
          transition: "width 0.3s ease",
        }} />
      </div>
    </div>
  );
}

export function StepProgress({ steps = [], current = 0, color = t.emerald }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", fontFamily: font.body }}>
      {steps.map((label, i) => {
        const completed = i < current;
        const active = i === current;
        const circleColor = completed || active ? color : t.border;

        return (
          <div key={i} style={{ display: "flex", alignItems: "center", flex: i < steps.length - 1 ? 1 : "none" }}>
            {/* Step circle + label */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, minWidth: 28 }}>
              <div style={{
                width: 28, height: 28, borderRadius: "50%",
                background: completed ? color : active ? `${color}18` : t.surface,
                border: `2px solid ${circleColor}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 11, fontWeight: 700, fontFamily: font.mono,
                color: completed ? "#fff" : active ? color : t.textMuted,
                boxShadow: active ? `0 0 0 3px ${color}20` : "none",
                transition: "all 0.2s",
              }}>
                {completed ? "✓" : i + 1}
              </div>
              <span style={{
                fontSize: 10, fontWeight: active ? 700 : 500,
                color: active ? color : completed ? t.textPrimary : t.textMuted,
                whiteSpace: "nowrap", letterSpacing: "0.02em",
              }}>{label}</span>
            </div>
            {/* Connector line */}
            {i < steps.length - 1 && (
              <div style={{
                flex: 1, height: 2, margin: "0 6px",
                marginTop: -14,
                background: completed ? color : t.border,
                transition: "background 0.2s",
              }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
